import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { User } from 'projects/shared/src/models/auth';
import { Notification, NotificationsModel } from 'projects/shared/src/models/Notification';
import { AuthenticationService } from 'projects/shared/src/services/authentication.service';
import { NavigationService } from 'projects/shared/src/services/navigation.service';
import { UserTypeEnum } from 'projects/shared/src/models/global/enums/UserType.enum';
import { NotificationsService } from 'projects/shared/src/services/notifications.service';
import { SignalRService } from 'projects/shared/src/services/signal-rservice.service';
import { SignalEventType } from 'projects/shared/src/models/SignalModel';

@Component({
  selector: 'app-header',
  standalone: false,
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {
  @Output() sidebarTrigger = new EventEmitter();
  @Input() fromCentralHub!: boolean
  notificationNumber: number = 0;
  currentUser: User | null = new User();
  userMenu = false;
  shouldShow = false;

  notifLoading = false;
  pageNumber = 1;
  pageSize = 10;
  pageCount: number = 0;
  notificationMenu = false;
  notificationsResult: any = {
    unSeenNotificationsCount: 0,
    totalCount: 0,
  };
  notificationsList: Notification[] = [];
  NotificationsModel = new NotificationsModel();
  activeAlerts = {};
  subscriptions: Subscription[] = [];

  actionsPermissions: any;

  userType = UserTypeEnum;

  language = localStorage.getItem('language') || 'ar';

  constructor(
    private router: Router,
    public translate: TranslateService,
    public dialogRef: MatDialog,
    public navService: NavigationService,
    private authenticationService: AuthenticationService,
    private notificationsService: NotificationsService,
    private signal: SignalRService,

    // public LookupsService: LookupsService
  ) {
    // this.currentUser = this.authenticationService.currentUserValue;
    // this.getNotifications();

    // this.GetUnseenNotificationCount();


    // this.authenticationService.actionsPermissions.subscribe((data: any) => {
    //   this.actionsPermissions = data;
    // });
  }

  ngOnInit() {
    console.log(this.currentUser);
    this.subscriptions.push(
      this.authenticationService.currentUser$.subscribe(user => {
        this.currentUser = user;
      })
    );

    this.subscriptions.push(
      this.signal.getDataStream<string>(SignalEventType.changeNotificationCount)
        .subscribe(message => {
          this.updateNotification(message.data);
        })
    )
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  updateNotification(data: any) {
    this.getNotifications();
  }

  // Actions
  changeLanguage() {
    let lang = this.language == 'en' ? 'ar' : 'en'
    localStorage.setItem('language', lang);
    window.location.reload();
  }

  logout() {
    this.authenticationService.logout();
    this.router.navigate(['/login']);
  }

  // Notifications
  // GetUnseenNotificationCount() {
  //   this.notificationsService.GetUnseenNotificationCount().subscribe(
  //     result => {
  //       this.notificationsResult.unSeenNotificationsCount = result;
  //     }, err => {
  //       console.error(err);
  //     });
  // }

  seeNotifications(notif: Notification) {
    this.notificationsService.SeeNotifications(notif.notificationId).subscribe(
      (result) => {
        this.notificationsResult.unSeenNotificationsCount = result
      }, err => {
        console.error(err);
      });
  }
  openNotificationPanel() {
    this.notificationMenu = !this.notificationMenu;
    this.userMenu = false;
    if (!this.notificationsList.length) {
      this.getNotifications();
    }
  }
  // getNextPage(index: number) {
  //   const endIndex = this.notificationsList.length - 1;
  //   console.log(this.notificationsResult.totalCount);
  //   console.log(this.notificationsList.length);

  //   if (this.pageNumber != this.pageCount && index >= endIndex) {
  //     this.pageNumber += 1;
  //     this.getNotifications(false , true);
  //   }
  // }
  getNextPage() {
    if (this.pageNumber < this.pageCount) {
      this.pageNumber += 1;
      this.getNotifications(false, true);
    }
  }
  getNotifications(update = true, isScroll = false) {
    if (update) {
      this.pageNumber = 1;
      this.notificationsList = [];
    }
    this.notifLoading = !isScroll;
    this.NotificationsModel.pageSize = this.pageSize;
    this.NotificationsModel.pageNumber = this.pageNumber;
    this.notificationsService.GetNotifications(this.NotificationsModel).subscribe(
      result => {
        this.notifLoading = false;
        this.notificationsResult = result;
        this.pageCount = Math.ceil(this.notificationsResult.totalCount / this.pageSize);
        this.notificationsList = this.notificationsList.concat(this.notificationsResult.pageData);
        // this.notificationsResult.unSeenNotificationsCount = 0;
      }, err => {
        this.notifLoading = false;
        console.error(err);
      });
  }

  toggelSidebar() {
    const state = this.navService.sidebarState;
    state.sidenavOpen = !state.sidenavOpen;
  }

}
